module.exports = __webpack_public_path__ + "assets/img/block-hover-bbc75f62.png";